import mixpanel from "mixpanel-browser";

type MixpanelEvent = {
  name: string;
  properties?: Record<string, any>;
};

export function isMixpanelReady(): boolean {
  try {
    return !!mixpanel.get_config?.("token");
  } catch {
    return false;
  }
}

export const trackEvent = ({ name, properties = {} }: MixpanelEvent) => {
  // Don't run analytics in storybook
  if (process.env.STORYBOOK) {
    return;
  }
  if (isMixpanelReady()) {
    // Only log in non-production environments, and redact sensitive fields
    if (process.env.NODE_ENV !== "production") {
      const { userId, enterpriseId, email, ...safeProps } = properties;
      console.log("[Mixpanel] Tracking event:", name, {
        ...safeProps,
        userId: userId ? "[REDACTED]" : undefined,
        enterpriseId: enterpriseId ? "[REDACTED]" : undefined,
        email: email ? "[REDACTED]" : undefined,
      });
    }
    mixpanel.track(name, properties);
  } else if (process.env.NODE_ENV !== "production") {
    console.warn("[Mixpanel] Not initialized - cannot track event:", name);
  }
};

export const trackPageView = (
  page: string,
  properties?: Record<string, any>
) => {
  // Don't run analytics in storybook
  if (process.env.STORYBOOK) {
    return;
  }
  if (isMixpanelReady()) {
    // Only log in non-production environments, and redact sensitive fields
    if (process.env.NODE_ENV !== "production" && properties) {
      const { userId, enterpriseId, email, ...safeProps } = properties;
      console.log("[Mixpanel] Tracking page view:", page, {
        ...safeProps,
        userId: userId ? "[REDACTED]" : undefined,
        enterpriseId: enterpriseId ? "[REDACTED]" : undefined,
        email: email ? "[REDACTED]" : undefined,
      });
    } else if (process.env.NODE_ENV !== "production") {
      console.log("[Mixpanel] Tracking page view:", page);
    }
    mixpanel.track(`Page View: ${page}`, properties);
  } else if (process.env.NODE_ENV !== "production") {
    console.warn("[Mixpanel] Not initialized - cannot track page view:", page);
  }
};
